<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>الحوافظ</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
            هنا يتم عرض جميع الحوافظ
              <div class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='form-group col-lg-3 col-sm-3'>
                <label>الفرع:</label>
                <select  @change='FillItineraries()' class="form-control" style="padding: 0px" v-model="branch">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='form-group col-lg-3 col-sm-3'>
                <tbDate  :mytitle='dateTitle' v-model= 'date' :today='today' ></tbDate>
              </div>
              <div class='form-group col-lg-3 col-sm-3' style="padding-top:24px">
                <button @click='GetData(0)' type='button' class='btn btn-primary btn-md btn-block'>عرض</button>
              </div>
              <div class='form-group col-lg-3 col-sm-3' style="padding-top:24px">
                <button @click='GetData(1)' type='button' class='btn btn-primary btn-md btn-block'>عرض النشط</button>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>الاسم</th>
                    <th style='text-align: center'>التاريخ</th>
                    <th style='text-align: center'>المحصل</th>
                    <th style='text-align: center'>المناطق</th>
                    <th style='text-align: center'>الايصالات</th>
                    <th style='text-align: center'>الحالة</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                    <td align='center'>{{record.receipt_folder_name}}</td>
                    <td align='center'>{{record.date}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>{{record.count}}</td>
                    <td align='center'>{{record.receipt_count}}</td>
                    <td align='center'>{{record.status_str}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <label>الفرع:</label>
                    <select @change='getReceiptFolders();FillItineraries()' class="form-control" v-model="branch">
                      <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>

                  <div class='form-group col-lg-6 col-sm-6'>
                    <label>المجموعة:</label>
                    <vue-element-loading size='32' :active='isLoadingReceiptFolders' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <select class="form-control" style="padding: 0px" v-model="record.receipt_folder_id">
                      <option v-for="item in receiptFolders" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.receipt_folder_name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-6 col-sm-6'>
                    <label>الحالة:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.status">
                      <option v-for="item in rec_status" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <tbDate  :mytitle='dateTitle' v-model= 'record.date' :today='today' ></tbDate>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <label>الفنى:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.user_tec_id">
                      <option v-for="item in technicals" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <div class="form-group">
                      <label>الخط</label>
                      <vue-element-loading size='32' :active='isLoadingItineraries' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <select @change='FillRegions()' class="form-control" style="padding: 0px" v-model="itinerarie">
                        <option v-for="item in itineraries" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class='form-group col-lg-12 col-sm-12'>
                    <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button @click='saveData' type='button' class='btn btn-primary btn-md btn-block'>حفظ</button>
                  </div>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <vue-element-loading size='32' :active='isLoadingRegions' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <div class="chat-panel panel panel-default">
                    <div class="panel-heading">
                      مناطق الخط
                      <div class="pull-left">
                        <div class="btn-group">
                          <button  v-show="regions.length > 0" @click='addAll()' type="button" class="btn btn-default btn-xs" >
                            >>>>>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- /.panel-heading -->
                    <div class="panel-body" style="padding: 5px">
                      <table width='100%' class='table table-bordered table-hover' id='dataTables-example'>
                        <tbody>
                          <tr style="padding:2px;-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" class='odd gradeX' v-for='record in regions' :key='record.id' v-on:click="addRec(record)">
                            <td style="padding:2px;-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" align='center'>{{record.region_name}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <div class="chat-panel panel panel-default">
                    <div class="panel-heading">
                      مناطق الحافظة
                      <div class="pull-left">
                        <div class="btn-group">
                          <button  v-show="record.regions" @click='emptyAll()' type="button" class="btn btn-default btn-xs" >
                            XXXXX
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- /.panel-heading -->
                    <div class="panel-body" style="padding: 5px">
                      <table width='100%' class='table table-bordered table-hover' id='dataTables-example'>
                        <tbody>
                          <tr style="padding:2px;-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" class='odd gradeX' v-for='record in record.regions' :key='record.id' v-on:click="removeRec(record)">
                            <td style="padding:2px;-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" align='center'>{{record.region_name}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'folders',
  data () {
    return {
      rec_status: [
        {id: 0, name: 'غير نشط'},
        {id: 1, name: 'نشط'}
      ],
      dateTitle: 'التاريخ',
      receiptFolders: {},
      date: '',
      branches: {},
      itineraries: {},
      itinerarie: '',
      regions: {},
      region_id: '',
      branch: 0,
      technicals: '',
      validationErrors: '',
      records: {},
      record: {},
      today: true,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingRegions: false,
      isLoadingItineraries: false,
      isLoadingReceiptFolders: false,
      title: ''
    }
  },
  created (id) {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch = localStorage.getItem('BrancheID')
    this.GetData(1)
  },
  methods: {
    getReceiptFolders () {
      this.isLoadingReceiptFolders = true
      axios.post(this.$apiURL + 'getReceipt_folders', {
        token: localStorage.getItem('token'),
        branch_id: this.branch
      })
        .then(({ data }) => {
          this.receiptFolders = data
          this.isLoadingReceiptFolders = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingReceiptFolders = false
        })
    },
    FillItineraries () {
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch))
      if (i > -1) {
        this.technicals = this.branches[i].technicals
      }
      this.region_id = ''
      this.itinerarie = ''
      this.regions = ''
      this.isLoadingItineraries = true
      axios.post(this.$apiURL + 'get-branch-itineraries', {
        token: localStorage.getItem('token'),
        branch: this.branch
      })
        .then(res => {
          this.isLoadingItineraries = false
          this.itineraries = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillRegions () {
      this.region_id = ''
      this.isLoadingRegions = true
      axios.post(this.$apiURL + 'get-branch-regions', {
        token: localStorage.getItem('token'),
        line: this.itinerarie
      })
        .then(res => {
          this.isLoadingRegions = false
          this.regions = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    addRec (rec) {
      this.record.regions.push(rec)
      let i = this.regions.map(record => record.id).indexOf(rec.id)
      this.regions.splice(i, 1)
    },
    addAll () {
      this.record.regions.push(...this.regions)
      this.regions = []
    },
    emptyAll () {
      this.record.regions = []
    },
    removeRec (rec) {
      let i = this.record.regions.map(record => record.id).indexOf(rec.id)
      this.record.regions.splice(i, 1)
    },
    GetData (type) {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch))
      if (i > -1) {
        this.technicals = this.branches[i].technicals
      }
      this.FillItineraries()
      this.getReceiptFolders()
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-folders', {
        token: localStorage.getItem('token'),
        branch_id: this.branch,
        type: type,
        date: this.date
      })
        .then(({ data }) => {
          this.records = data
          for (let i = 0; i < this.records.length; i++) {
            this.records[i].count = this.records[i].regions.length
          }
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.isLoadingData = false
      this.isLoadingSave = false
      this.isLoadingDelete = false
      this.isLoadingRegions = false
      this.isLoadingItineraries = false
      this.isLoadingReceiptFolders = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'date': '', 'receipt_folder_id': '', 'regions': [], 'user_tec_id': '', 'status': 1}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.successShow = false
      this.errorShow = false
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'save-folder', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        receipt_folder_id: this.record.receipt_folder_id,
        date: this.record.date,
        regions: this.record.regions,
        status: this.record.status,
        user_tec_id: this.record.user_tec_id
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
          for (let i = 0; i < this.records.length; i++) {
            this.records[i].count = this.records[i].regions.length
          }
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'delete-folder', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Folders.vue